import React, { useCallback, useContext, useEffect, useState } from "react";
import FlechaIzquierdaIcon from "../../../assets/images/generico/FlechaIzquierdaIcon";
import TurnoCanceladoIcon from "../../../assets/images/generico/TurnoCanceladoIcon";
import TurnoNoAsistidoIcon from "../../../assets/images/generico/TurnoNoAsistidoIcon";
import TurnoRealizadoIcon from "../../../assets/images/generico/TurnoRealizadoIcon";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import {
  hideSegundoModal,
  showSegundoModal,
} from "../../../context/Actions/segundoModal/segundoModal";
import { wsGetPlanKinesio } from "../../../context/Actions/turnos/turnosPaciente";
import { PortalContext } from "../../../context/Provider";
import { amOrPm } from "../../../../global/utils/amOrPm";
import camelize from "../../../../global/utils/camelize";
import { getDiaStrTurno } from "../../../../global/utils/diasTurno";
import "./PlanTurnosKinesio.css";

const PlanTurnosKinesio = ({
  medico,
  hora,
  fecha,
  estadoTurno,
  centro,
  ubicacion,
  coordenadaGps,
  idturno,
  especialidad,
  idTurnoSesion,
  esUltimo,
  idPacienteFamiliar,
}) => {
  const [selected, setSelected] = useState(false);
  const { segundoModalDispatch, motivoCancelacionState, modalDispatch } =
    useContext(PortalContext);

  const handleClickTurnos = () => {
    if (!selected || selected !== idturno) {
      setSelected(idturno);
    } else {
      setSelected(false);
    }
  };

  const dissmiss = () => {
    hideSegundoModal()(segundoModalDispatch);
  };

  const pasoACancelar = () => {
    hideSegundoModal()(segundoModalDispatch);
    setTimeout(() => {
      cancelarSesion();
    }, 50);
  };

  const confirmacionCancelar = () => {
    showSegundoModal(
      "Turnos/KinesiCancelModal/KinesioCancelModal",
      {
        titulo: "Información",
        modalCancelar: () => pasoACancelar(),
      },
      {},
      "centro"
    )(segundoModalDispatch);
  };

  const cancelarSesion = () => {
    showSegundoModal(
      "Turnos/MensajeCancelarTurno/MensajeCancelarTurno",
      {
        titulo: "Cancelar turno",
        texto: `Desea cancelar su turno de ${especialidad} del ${getDiaStrTurno(
          fecha
        )} ${getDiaStrTurno(fecha, true)} a las ${hora} ${amOrPm(hora)} ?`,
        items: motivoCancelacionState.motivoCancelacion.turnos,
        idTurnoSesion: idTurnoSesion,
        idturno: idturno,
        dissmiss: dissmiss,
        idPacienteFamiliar: idPacienteFamiliar,
        esUltimo,
      },
      {},
      "centro"
    )(segundoModalDispatch);
  };

  return (
    <React.Fragment>
      <div className="ptur-planTurnosKinesio-card">
        <div>
          <ul className="ptur-list-planTurnosKinesio">
            <li
              className="ptur-option-planTurnosKinesio rb14b"
              id={selected ? "active" : ""}
              onClick={handleClickTurnos}
            >
              <div className="ptur-planTurnosKinesio-tituloFlecha">
                <span>
                  {estadoTurno === "Pendiente" ? (
                    <TurnoRealizadoIcon
                      color="#ECECEC"
                      circulo="#d4d4d4"
                      tilde="#d4d4d4"
                      width="27"
                      height="27"
                    />
                  ) : (
                    ""
                  )}
                  {estadoTurno === "Atendido" ? (
                    <TurnoRealizadoIcon
                      color="#3D994A"
                      circulo="#296632"
                      tilde="#fff"
                      width="27"
                      height="27"
                    />
                  ) : (
                    ""
                  )}
                  {estadoTurno === "Cancelado" ? (
                    <TurnoCanceladoIcon color="#ECECEC" />
                  ) : (
                    ""
                  )}
                  {estadoTurno === "Ausente" ? (
                    <TurnoNoAsistidoIcon color="#C10C00" />
                  ) : (
                    ""
                  )}
                </span>

                <p className="ptur-planTurnosKinesio-diaHora rb16b">
                  {getDiaStrTurno(fecha, false, true)}
                  {getDiaStrTurno(fecha, true, true)}{" "}
                  <span className="ptur-cardTurnosKin-box-bodyHora rb18l">{`${hora}hs`}</span>
                </p>

                {selected ? (
                  <div className="ptur-planTurnosKinesio-flechaCerrar">
                    <FlechaIzquierdaIcon />
                  </div>
                ) : (
                  <div className="ptur-planTurnosKinesio-flechaAbrir">
                    <FlechaIzquierdaIcon />
                  </div>
                )}
              </div>
              <React.Fragment>
                <div className="ptur-planTurnosKinesio-textoCard">
                  {selected === idturno ? (
                    <>
                      <div className="ptur-planTurnosKinesio-especialistaConsulta">
                        <ul className="ptur-planTurnosKinesio-listadoPlan">
                          <li className="rb16t">
                            Especialista:{" "}
                            <span className="rb16b">{camelize(medico)}</span>
                          </li>
                          <li className="rb16t">
                            Tipo de Consulta:{" "}
                            <span className="rb16b">Presencial</span>
                          </li>
                        </ul>
                      </div>
                      <div className="ptur-planTurnosKinesio-centroGps">
                        <div className="rb16b">{centro}</div>
                        <div className="rb12l">
                          <a
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            href={`https://maps.google.com/?q=${coordenadaGps}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {ubicacion}
                          </a>
                        </div>
                      </div>
                      {estadoTurno === "Pendiente" ? (
                        <div className="ptur-planTurnosKinesio-btnCancelarContainer">
                          <button
                            className="ptur-planTurnosKinesio-btnCancelar rb16m c-white"
                            onClick={(e) => {
                              e.stopPropagation();
                              confirmacionCancelar();
                            }}
                          >
                            Cancelar turno
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </React.Fragment>
            </li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PlanTurnosKinesio;
